import { Component, OnInit } from '@angular/core';
import { URLS } from '../../shared/constant/interface';
import { _MSGTYPES } from '../../shared/constant/msgType';

@Component({
  selector: 'icc-voice-modal-detail',
  templateUrl: './voice-modal-detail.component.html',
  styles: [],
})
export class VoiceModalDetailComponent implements OnInit {
  constructor() {}
  SCENE = 'icc-msg-modal-detail';
  type = _MSGTYPES.MT.VOICE.type;
  isMo: boolean;
  title: string;
  // 下行内容
  mtContent: string;
  // 上行语音地址
  moAudioUrl: string;
  ngOnInit() {
    this.moAudioUrl = URLS.attachment.url + '?' + this.moAudioUrl;
  }
}
